.edit-icon {
  height: calc(3 * var(--spacer));
}

gz-form-field {
  --margin-bottom-wrapper: 0;
  height: calc(var(--spacer) * 4);
  margin: calc(var(--spacer) / 2) 0;

  .dropdown {
    position: absolute;
    top: 0;
    width: 100%;
  }
}
